import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { saveProfessionalExperience, selectProfile } from "../../Redux/ResumeReducer/ResumeAction";
import { getCandidateProfileById, getUserById, view_resume } from "../../Api/apiService";
import { toast } from "react-toastify";
import "./CreateResume.css";
import "./ProfessionalExperience.css";
import LayoutHOC from "../../Components/Hoc/ResumeHoc";
import ContainerWrapper from "../../Components/ContainerWrapper/container-wrapper";
import { Col, DatePicker, Row } from "antd";
import ResumeSidebar from "../../Components/Sidebar/Resume-Sidebar";
import CreateResumeWrapper from "./components/Create-Resume-Wrapper";
import { ChevronDown, ChevronUp, Plus } from "lucide-react";
import InputWrapper from "../../Components/Input/Input-Wrapper";
import CustomInput from "../../Components/Input/Custom-Input";
import LottieIcon from "../../Components/LottieIcon/LottieIcon";
import TextArea from "antd/es/input/TextArea";
import CustomizeButton from "../../Components/Button/Customize-Button";
import dayjs from "dayjs";

function ProfessionalExperience() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const profileId = new URLSearchParams(location.search).get("profileId");
  console.log(profileId, "this is profile id ");
  const candidateUserId = new URLSearchParams(location.search).get("candidateProfileId");

  console.log(candidateUserId, "this is candidate Id");
  const resume = useSelector((state) => state.resume);
  const selectedProfile = useSelector((state)=> state.resume.selectedProfile);
 console.log(resume, "this is resume from redux");

  const user = JSON.parse(localStorage.getItem("auth")) || { userId: "" };
  const candidateId = localStorage.getItem("profileId") || { profileId: "" };
  const employeeId = localStorage.getItem("employeeId") || { employeeId: "" };
  const role = localStorage.getItem("selectedRole") || { selectedRole: "" };

  const [experiences, setExperiences] = useState([
    {
      id: Date.now(),
      open: true,
      jobTitle: "",
      companyName: "",
      projectName: "",
      startDate: "",
      endDate: "",
      techStack: "",
      details: "",
    },
  ]);

  let [id, setId] = useState("");

  const savedProfessionalExperience = useSelector((state) => state.resume.profileData.professionalExperience || []);

  const [experienceFields, setExperienceFields] = useState([
    { jobTitle: "", companyName: "", projectName: "", startDate: "", endDate: "", techStack: "", details: "" },
  ]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const userDet = useSelector((state) => state.auth);
  const { userId } = userDet;
  const [userDetails, setUserDetails] = useState();
  const [showModal, setShowModal] = useState(false);
  const [editFieldIndex, setEditFieldIndex] = useState(null);
    const [resumeTitle, setResumeTitle] = useState("");
  const [editField, setEditField] = useState({
    jobTitle: "",
    companyName: "",
    projectName: "",
    startDate: "",
    endDate: "",
    techStack: "",
    details: "",
  });


const getCandidateDetailsForExperience = async () => {
  console.log("getCandidateDetailsForExperience called");

  const professionalExperienceData = resume?.profileData?.professionalExperience || [];
  console.log(professionalExperienceData, "professional experience from redux");

  // ✅ If experience data is already available in Redux, use it directly
  if (professionalExperienceData.length > 0) {
    console.log("Loading professional experience from Redux");

    const formattedExperienceFields = professionalExperienceData.map((exp, index) => ({
      id: Date.now() + index, // generate unique id
      open: true,             // default expanded
      jobTitle: exp.jobTitle || "",
      companyName: exp.companyName || "",
      projectName: exp.projectName || "",
      startDate: exp.startDate || "",
      endDate: exp.endDate || "",
      techStack: exp.techStack || "",
      details: exp.details || "",
    }));

    console.log(formattedExperienceFields, "formatted experience from redux");
    setExperiences(formattedExperienceFields);
    return; // 🧠 Stop here — no API call needed
  }

  // ❌ Otherwise, fetch data from API
  console.log("Fetching professional experience from API...");
  try {
    const response = await getCandidateProfileById(candidateId);
    console.log(response, "response from API");

    if (response?.status === 200 || response?.status === 201) {
      const profile = response.data.profileData;
      const experienceData = profile?.professionalExperience || [];
      setResumeTitle(response.data.resumeTitle || "");
      if (experienceData.length > 0) {
        const formattedExperienceFields = experienceData.map((exp, index) => ({
          id: Date.now() + index,
          open: true,
          jobTitle: exp.jobTitle || "",
          companyName: exp.companyName || "",
          projectName: exp.projectName || "",
          startDate: exp.startDate || "",
          endDate: exp.endDate || "",
          techStack: exp.techStack || "",
          details: exp.details || "",
        }));

        console.log(formattedExperienceFields, "formatted experience from API");
        setExperiences(formattedExperienceFields);
      }
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong.", {
      autoClose: 2000,
    });
  }
};


  const getUserDetails = async () => {
    if (role === "employee") {
      const response = await getUserById(user.userId);
      try {
        if (response?.status === 200 || response?.status === 201) {
          setUserDetails(response.data);
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Something went wrong.", {
          autoClose: 2000,
        });
      }
    } else {
      const response = await getUserById(userId);
      try {
        if (response?.status === 200 || response?.status === 201) {
          setUserDetails(response.data);
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Something went wrong.", {
          autoClose: 2000,
        });
      }
    }
  };

  // Load from Redux/localStorage immediately
 useEffect(() => {
    if (savedProfessionalExperience && savedProfessionalExperience.length > 0) {
      setExperiences(savedProfessionalExperience);
    } else {
      // fallback: load from localStorage
      const localData = JSON.parse(localStorage.getItem("professionalExperience") || "[]");
      if (localData.length > 0) {
        setExperiences(localData);
        dispatch(saveProfessionalExperience(localData));
      }
    }
  }, []);


  useEffect(() => {
    if (role !== "candidate") {
      getUserDetails();
    } else {
      getCandidateDetailsForExperience();
    }
  }, []);


 useEffect(() => {
  if (selectedProfile?.profileData?.professionalExperience && selectedProfile.profileData.professionalExperience.length > 0) {
    const formattedFields = selectedProfile.profileData.professionalExperience.map((exp) => ({
      jobTitle: exp.jobTitle || "",
      companyName: exp.companyName || "",
      projectName: exp.projectName || "",
      startDate: exp.startDate || "",
      endDate: exp.endDate || "",
      techStack: exp.techStack || "",
      details: exp.details || "",
    }));
    setExperiences(formattedFields);
  }
}, [selectedProfile]);

  const handlePrevClick = () => {
    if (role === "employee") {
      navigate(profileId ? `/education?profileId=${profileId}` : "/education");
    } else if (role === "candidate") {
      navigate(`/education?candidateProfileId=${candidateUserId}`);
    } else {
      navigate(profileId ? `/education?profileId=${profileId}` : "/education");
    }
  };

  // const handleNextClick = () => { //KEEP THIS IF SAID TO KEEP
  //   if (experienceFields.length > 0) {
  //     dispatch(saveProfessionalExperience(experienceFields));
  //   }

  //   if (role === "employee") {
  //     navigate(profileId ? `/skills?profileId=${profileId}` : "/skills");
  //   } else if (role === "candidate") {
  //     navigate(candidateId ? `/skills?candidateProfileId=${candidateId}` : "/skills");
  //   } else {
  //     navigate(profileId ? `/skills?profileId=${profileId}` : "/skills");
  //   }
  // };
  const addExperience = () => {
    // validation like education
    const lastExp = experiences[experiences.length - 1];
    if (!lastExp.jobTitle || !lastExp.companyName || !lastExp.startDate) {
      toast.error("Please fill all required fields before adding another experience");
      return;
    }

    setExperiences((prev) => {
      const updated = prev.map((exe) => ({ ...exe, open: false }));

      const newExe = {
        id: Date.now(),
        open: true,
        jobTitle: "",
        companyName: "",
        projectName: "",
        startDate: "",
        endDate: "",
        techStack: "",
        details: "",
      };

      return [...updated, newExe];
    });
  };

  const handleNextClick = () => {
    const formattedExperiences = experiences
      .map((exp) => ({
        jobTitle: exp.jobTitle?.trim(),
        companyName: exp.companyName?.trim(),
        projectName: exp.projectName?.trim(),
        startDate: exp.startDate || "",
        endDate: exp.endDate || "",
        techStack: exp.techStack?.trim(),
        details: exp.details?.trim(),
      }))
      // filter out completely empty rows
      .filter((exp) => exp.jobTitle || exp.companyName || exp.projectName || exp.startDate || exp.endDate || exp.techStack || exp.details);

    // ✅ dispatch only once here
    dispatch(saveProfessionalExperience(formattedExperiences));

     if (selectedProfile) {
    dispatch(selectProfile({
      ...selectedProfile,
      profileData: {
        ...selectedProfile.profileData,
        professionalExperience: formattedExperiences,
      },
    }));
  }

    

    if (role === "employee") {
      navigate(profileId ? `/skills?profileId=${profileId}` : "/skills");
    } else if (role === "candidate") {
      navigate(candidateId ? `/skills?candidateProfileId=${candidateId}` : "/skills");
    } else {
      navigate(profileId ? `/skills?profileId=${profileId}` : "/skills");
    }
  };

  const handleDetailsChange = (value, index) => {
    const updatedFields = experienceFields.map((field, i) => {
      if (i === index) {
        // If the field is empty, prepend a bullet point
        const updatedDetails = !field.details && value.trim() !== "" ? `• ${value}` : value;
        return { ...field, details: updatedDetails };
      }
      return field;
    });
    setExperienceFields(updatedFields);
  };

  const handlePlusClick = () => {
    setExperienceFields([
      { jobTitle: "", companyName: "", projectName: "", startDate: "", endDate: "", techStack: "", details: "" },
      ...experienceFields,
    ]);
  };

  const handleDeleteClick = (index) => {
    const updatedFields = experienceFields.filter((_, i) => i !== index);
    setExperienceFields(updatedFields);
  };

  const handleEditClick = (index) => {
    setEditField(experienceFields[index]);
    setEditFieldIndex(index);
    setShowModal(true);
  };

  const handleFieldChange = (index, fieldName, value) => {
    const updatedFields = experienceFields.map((field, i) => (i === index ? { ...field, [fieldName]: value } : field));
    setExperienceFields(updatedFields);
  };

  const handleModalSave = () => {
    const updatedFields = [...experienceFields];
    updatedFields[editFieldIndex] = editField;
    setExperienceFields(updatedFields);
    setShowModal(false);
  };

 const handleKeyDown = (e, id) => {
  if (e.key === "Enter") {
    e.preventDefault();
    setExperiences((prev) =>
      prev.map((exp) => {
        if (exp.id === id) {
          const updatedDetails = (exp.details || "") + "\n• ";
          return { ...exp, details: updatedDetails };
        }
        return exp;
      })
    );
  }
};
  const removeExperience = (id) => {
    setExperiences((prev) => prev.filter((exp) => exp.id !== id));
  };
const handleExperienceChange = (id, field, value) => {
  setExperiences((prev) =>
    prev.map((exp) => {
      if (exp.id === id) {
        if (field === "details" && !exp.details && value.length === 1) {
          return { ...exp, [field]: "• " + value };
        }
        return { ...exp, [field]: value };
      }
      return exp;
    })
  );
};
  const toggleOpen = (id) => {
    setExperiences((prev) => prev.map((exp) => (exp.id === id ? { ...exp, open: !exp.open } : exp)));
  };

    const handleCancel = () => {
      navigate(user?.role === "ROLE_HR"  ? "/dashboardHr" : "/dashboard");
  }

  return (
    <>
      <ContainerWrapper breadcrumbItems={["Resume Builder", "Professional Experience"]}>
        <Row gutter={[20, 20]}>
          <Col span={6}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div>
                <ResumeSidebar title={resumeTitle || selectedProfile?.jobTitle || "Resume Title"} />
              </div>
            </div>
          </Col>
          <Col span={18}>
            <CreateResumeWrapper title={"Professional Experience"}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  {experiences.map((exe, index) => (
                    <Row
                      style={{
                        borderRadius: "10px",
                        padding: "16px",
                        border: "1px solid #E8E8E8",
                        marginBottom: "12px",
                      }}
                    >
                      <Row style={{ width: "100%" }}>
                        <Col
                          span={24}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "20px",
                            paddingRight: "10px",
                          }}
                        >
                          <Row
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "8px",
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    color: "#000000",
                                  }}
                                >
                                  {exe.jobTitle || exe.companyName
                                    ? `${exe.jobTitle || "Job Title"} at ${exe.companyName || "Company Name"}`
                                    : "Job Title at Company Name"}
                                </span>
                                <span
                                  style={{
                                    fontSize: "12px",
                                    color: "#8B8B8B",
                                  }}
                                >
                                  {exe.startDate && exe.endDate
                                    ? `${dayjs(exe.startDate, "DD-MM-YYYY").format("MMM YYYY")} - ${dayjs(exe.endDate, "DD-MM-YYYY").format(
                                        "MMM YYYY"
                                      )}`
                                    : "From - To"}
                                </span>
                              </div>

                              <div style={{ cursor: "pointer", display: "flex" }} onClick={() => toggleOpen(exe.id)}>
                                {experiences.length > 1 && index !== experiences.length - 1 && (
                                  <div
                                    style={{ marginLeft: "8px", cursor: "pointer" }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      removeExperience(exe.id);
                                    }}
                                  >
                                    <LottieIcon name="trashIcon" size={24} />
                                  </div>
                                )}
                                {exe.open ? <ChevronUp /> : <ChevronDown />}
                              </div>
                            </div>
                            <div className={`education-collapse ${exe.open ? "open" : ""}`}>
                              <div>
                                <Row
                                  style={{
                                    width: "100%",
                                    marginTop: "20px",
                                  }}
                                >
                                  <Col span={12} style={{ paddingRight: "10px" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "10px",
                                      }}
                                    >
                                      <InputWrapper label="Job Title" required>
                                        <CustomInput
                                          value={exe.jobTitle}
                                          onChange={(e) => handleExperienceChange(exe.id, "jobTitle", e.target.value)}
                                        />
                                      </InputWrapper>

                                      <InputWrapper label="Company Name" required>
                                        <CustomInput
                                          value={exe.companyName}
                                          onChange={(e) => handleExperienceChange(exe.id, "companyName", e.target.value)}
                                        />
                                      </InputWrapper>
                                      <InputWrapper label="End Date" required>
                                        <DatePicker
                                          onChange={(date, dateString) => handleExperienceChange(exe.id, "endDate", dateString)}
                                          style={{
                                            height: "46px",
                                            borderRadius: "10px",
                                            border: "1px solid #E8E8E8",
                                            boxShadow: "none",
                                            width: "100%",
                                          }}
                                          value={exe.endDate ? dayjs(exe.endDate, "DD-MM-YYYY") : null}
                                          format="DD-MM-YYYY"
                                          placeholder=""
                                        />
                                      </InputWrapper>
                                    </div>
                                  </Col>
                                  <Col span={12} style={{ paddingLeft: "10px" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "10px",
                                      }}
                                    >
                                      <InputWrapper label="Project Name" required>
                                        <CustomInput
                                          value={exe.projectName}
                                          onChange={(e) => handleExperienceChange(exe.id, "projectName", e.target.value)}
                                        />
                                      </InputWrapper>

                                      <InputWrapper label="Start Date" required>
                                        {/* <CustomInput
                                          value={exe.startDate}
                                          onChange={(e) => handleExperienceChange(exe.id, "startDate", e.target.value)}
                                        /> */}
                                        <DatePicker
                                          onChange={(date, dateString) => handleExperienceChange(exe.id, "startDate", dateString)}
                                          style={{
                                            height: "46px",
                                            borderRadius: "10px",
                                            border: "1px solid #E8E8E8",
                                            boxShadow: "none",
                                            width: "100%",
                                          }}
                                          placeholder=""
                                          value={exe.startDate ? dayjs(exe.startDate, "DD-MM-YYYY") : null}
                                          format="DD-MM-YYYY"
                                        />
                                      </InputWrapper>

                                      <InputWrapper label="Tech Stack" required>
                                        <CustomInput
                                          value={exe.techStack}
                                          onChange={(e) => handleExperienceChange(exe.id, "techStack", e.target.value)}
                                        />
                                      </InputWrapper>
                                    </div>
                                  </Col>
                                </Row>
                                <Row
                                  style={{
                                    width: "100%",
                                    marginTop: "10px",
                                  }}
                                >
                                  <InputWrapper className="bio-wrapper" label={"Details"}>
                                    <TextArea
                                      value={exe.details}
                                       onKeyDown={(e) => handleKeyDown(e, exe.id)}
                                      onChange={(e) => handleExperienceChange(exe.id, "details", e.target.value)}
                                      style={{
                                        border: "1px solid #E8E8E8",
                                        borderRadius: "10px",
                                        width: "100%",
                                        height: "20vh",
                                        padding: "12px",
                                        resize: "none",
                                      }}
                                      placeholder=""
                                    />
                                  </InputWrapper>
                                </Row>
                              </div>
                            </div>
                          </Row>
                        </Col>
                      </Row>
                    </Row>
                  ))}
                  <div
                    style={{
                      color: "#910E11",
                      marginTop: "5px",
                      padding: "10px",
                      display: "flex",
                      cursor: "pointer",
                    }}
                    onClick={addExperience}
                  >
                    <div style={{ marginRight: "10px" }}>
                      <Plus size={20} />
                    </div>
                    <div
                      style={{
                        fontSize: "16px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      Add Another Experience
                    </div>
                  </div>
                </div>
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                  }}
                >
                  <CustomizeButton onClick={handleNextClick} variant="primary" style={{ width: "14rem" }}>
                    {" "}
                    Save & Next{" "}
                  </CustomizeButton>
                  <CustomizeButton onClick={handlePrevClick} variant="outlined" style={{ width: "14rem" }}>
                    {" "}
                    Previous
                  </CustomizeButton>
                  <CustomizeButton variant="outlined" style={{ width: "14rem" }} onClick={handleCancel}>
                    {" "}
                    Cancel
                  </CustomizeButton>
                </Row>
              </div>
            </CreateResumeWrapper>
          </Col>
        </Row>
      </ContainerWrapper>
    </>
    //     <div className="resume-form">
    //       <div>
    //         <h1 className="resume-form-title">Professional Experience</h1>
    //         {loading && <p>Loading...</p>}
    //         {error && <p className="error">{error}</p>}
    //         <div className="resume-professional-experience">
    //           <div className="resume-form-header">
    //             <FontAwesomeIcon icon={faPlus} className="resume-plus-icon" onClick={handlePlusClick} />
    //           </div>

    //           <div className="resume-entry">

    //   <div className="grid-container-2-col">
    //     <Input
    //       label="Job Title"
    //       name="jobTitle"
    //       type="text"
    //       className="resume-form-input-field"
    //       value={experienceFields[0].jobTitle}
    //       onChange={(e) => saveField(0, "jobTitle", e.target.value)}
    //     />
    //     <Input
    //       label="Company Name"
    //       name="companyName"
    //       type="text"
    //       className="resume-form-input-field"
    //       value={experienceFields[0].companyName}
    //       onChange={(e) => saveField(0, "companyName", e.target.value)}
    //     />
    //     <Input
    //       label="Project Name"
    //       name="projectName"
    //       type="text"
    //       className="resume-form-input-field"
    //       value={experienceFields[0].projectName}
    //       onChange={(e) => saveField(0, "projectName", e.target.value)}
    //     />
    //     <Input
    //       label="Start Date"
    //       name="startDate"
    //       placeholder="yyyy-mm-dd"
    //       type="text"
    //       className="resume-form-input-field"
    //       value={experienceFields[0].startDate}
    //       onChange={(e) => saveField(0, "startDate", e.target.value)}
    //     />
    //     <Input
    //       label="End Date"
    //       name="endDate"
    //       placeholder="yyyy-mm-dd"
    //       type="text"
    //       className="resume-form-input-field"
    //       value={experienceFields[0].endDate}
    //       onChange={(e) => saveField(0, "endDate", e.target.value)}
    //     />
    //     <Input
    //       label="Tech Stack"
    //       name="techStack"
    //       type="text"
    //       className="resume-form-input-field"
    //       value={experienceFields[0].techStack}
    //       onChange={(e) => saveField(0, "techStack", e.target.value)}
    //     />
    //      <div className="grid-container-1-col">
    //     <Input
    //       label="Details"
    //       name="details"
    //       type="textarea"
    //       className="edit-professional-field-details"
    //       value={experienceFields[0].details}
    //       onChange={(e) => saveField(0, "details", e.target.value)}
    //       onKeyDown={(e) => handleKeyDown(e, 0)}
    //     />
    //   </div>
    //   </div>
    // </div>

    //           {experienceFields.length > 1 && (
    //             <div className="education-table-container professional-experience-container">
    //               <table className="education-table">
    //                 <thead>
    //                   <tr>
    //                     <th>Job Title</th>
    //                     <th>Company Name</th>
    //                     <th>Project Name</th>
    //                     <th>Start Date</th>
    //                     <th>End Date</th>
    //                     <th>Tech Stack</th>
    //                     <th>Action</th>
    //                   </tr>
    //                 </thead>
    //                 <tbody>
    //                   {experienceFields.slice(1).map((field, index) => (
    //                     <tr key={index + 1}>
    //                       <td>{field.jobTitle}</td>
    //                       <td>{field.companyName}</td>
    //                       <td>{field.projectName}</td>
    //                       <td>{field.startDate}</td>
    //                       <td>{field.endDate}</td>
    //                       <td>{field.techStack}</td>
    //                       <td className="table-icons">
    //                         <FontAwesomeIcon icon={faEdit} className="resume-edit-icon" onClick={() => handleEditClick(index + 1)} />
    //                         <FontAwesomeIcon icon={faTrash} className="resume-delete-icon" onClick={() => handleDeleteClick(index + 1)} />
    //                       </td>
    //                     </tr>
    //                   ))}
    //                 </tbody>
    //               </table>
    //             </div>
    //           )}
    //         </div>
    //       </div>
    //       <div className="resume-form-btn">
    //         <Button onClick={handlePrevClick}>Previous</Button>
    //         <Button onClick={handleNextClick}>Next</Button>
    //       </div>

    //       {/* Edit Modal */}
    //       {showModal && (
    //         <Modal className ="edit-modal-content" show={showModal} onClose={() => setShowModal(false)}>
    //           <h2>Edit Professional Experience</h2>
    //           <div className="professionalExperience-modal-edit">
    //           <Input
    //             className="edit-professional-field"
    //             label="Job Title"
    //             value={editField.jobTitle}
    //             onChange={(e) => setEditField({ ...editField, jobTitle: e.target.value })}
    //           />
    //           <Input
    //           className="edit-professional-field"
    //             label="Company Name"
    //             value={editField.companyName}
    //             onChange={(e) => setEditField({ ...editField, companyName: e.target.value })}
    //           />
    //           <Input
    //           className="edit-professional-field"
    //             label="Project Name"
    //             value={editField.projectName}
    //             onChange={(e) => setEditField({ ...editField, projectName: e.target.value })}
    //           />
    //           <Input
    //           className="edit-professional-field"
    //             label="Start Date"
    //             value={editField.startDate}
    //             onChange={(e) => setEditField({ ...editField, startDate: e.target.value })}
    //           />
    //           <Input
    //           className="edit-professional-field"
    //             label="End Date"
    //             value={editField.endDate}
    //             onChange={(e) => setEditField({ ...editField, endDate: e.target.value })}
    //           />
    //           <Input
    //           className="edit-professional-field"
    //             label="Tech Stack"
    //             value={editField.techStack}
    //             onChange={(e) => setEditField({ ...editField, techStack: e.target.value })}
    //           />
    //           <Input
    //             type="textarea"
    //             className="edit-professional-field-details"
    //             label="Details"
    //             value={editField.details}
    //             onChange={(e) => setEditField({ ...editField, details: e.target.value })}
    //             onKeyDown={(e) => handleKeyDown(e, editFieldIndex)} // ✅ use editFieldIndex
    //           />

    //           </div>
    //           <Button onClick={handleModalSave}>Save & Next</Button>
    //         </Modal>
    //       )}
    //     </div>
  );
}

export default LayoutHOC(ProfessionalExperience, { withSidebar: true });
